import { ServiceLine } from 'api/types/service.types';
import { PlusIcon, ServiceSelectionTowelIcon } from 'assets/icons';
import { ReactComponent as CPIcon } from 'assets/images/service-selection/cp-home-new-icon.svg';
import { ReactComponent as SCIcon } from 'assets/images/service-selection/sc-home-new-icon.svg';
import Button from 'components/atoms/Button';
import type { PartnerIcon } from 'config/types';
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { styled } from 'styled-components';
import { getPartnerSpecificComponent } from 'utils/helpers';

// service item

export const Styledh3 = styled.h3`
  color: ${({ theme }) => theme.components.selectService.serviceItem.title.color};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.4px;

  @media (max-width: 330px) {
    font-size: 0.85em;
  }

  @media (max-width: 360px) {
    font-size: 0.88em;
  }
`;

export const StyledText = styled.p`
  font-size: 13px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px; /* 138.462% */
  letter-spacing: 0.2px;
  text-decoration-line: underline;
`;

export const StyledItem = styled(ListGroup.Item)`
  padding: 0.8rem 1rem;
`;

export const StyledIconContainer = styled.div`
  @media (max-width: 330px) {
    svg {
      width: 42px;
      height: 42px;
    }
  }

  @media (max-width: 360px) {
    svg {
      width: 45px;
      height: 45px;
    }
  }
`;

export const StyledIconWrapper = styled.div`
  margin-right: 4px;
`;

export const StyledAddIcon = styled(PlusIcon)`
  g {
    fill: ${({ theme }) => theme.colors.steelBlue};
  }
`;

export const StyledAddButton = styled(Button)<{ selected?: boolean }>`
  display: flex;
  width: ${({ theme }) => theme.components.selectService.serviceItem.addButton.width}px;
  height: ${({ theme }) => theme.components.selectService.serviceItem.addButton.height}px;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme, selected }) =>
    selected
      ? theme.components.selectService.serviceItem.addButton.backgroundColor.selected
      : theme.components.selectService.serviceItem.addButton.backgroundColor.unselected};
  flex-shrink: 0;
  color: ${({ theme, selected }) =>
    selected
      ? theme.components.selectService.serviceItem.addButton.textColor.selected
      : theme.components.selectService.serviceItem.addButton.textColor.unselected};
  border-color: ${({ theme, selected }) =>
    selected
      ? theme.components.selectService.serviceItem.addButton.borderColor.selected
      : theme.components.selectService.serviceItem.addButton.borderColor.unselected};

  border-width: ${({ theme }) =>
    theme.components.selectService.serviceItem.addButton.borderWidth
      ? `${theme.components.selectService.serviceItem.addButton.borderWidth}px !important`
      : ''};
  border-radius: ${({ theme }) =>
    theme.components.selectService.serviceItem.addButton.borderRadius
      ? `${theme.components.selectService.serviceItem.addButton.borderRadius}px !important`
      : ''};

  @media (max-width: 330px) {
    width: 74px;
    height: 35px;
    font-size: 0.75em;

    svg {
      width: 12px;
      height: 12px;
    }
  }

  &:hover,
  &:focus,
  &:active,
  &.btn-primary:not(:disabled):not(.disabled):active {
    color: ${({ theme, selected }) =>
      selected
        ? theme.components.selectService.serviceItem.addButton.textColor.selected
        : theme.components.selectService.serviceItem.addButton.textColor.unselected};
    border-color: ${({ theme, selected }) =>
      selected
        ? theme.components.selectService.serviceItem.addButton.borderColor.selected
        : theme.components.selectService.serviceItem.addButton.borderColor.unselected};
    background-color: ${({ theme, selected }) =>
      selected
        ? theme.components.selectService.serviceItem.addButton.backgroundColor.selected
        : theme.components.selectService.serviceItem.addButton.backgroundColor.unselected};
  }

  &:disabled {
    background-color: #f3f8fb;
    border-width: 1px;
    border-color: ${({ theme }) => theme.colors.blueGray};
    color: ${({ theme }) => theme.colors.staleBlue};
  }
`;

export const StyledDivRow = styled.div`
  display: flex;
`;

export const cpIcon: PartnerIcon<any> = {
  CAREEM: ServiceSelectionTowelIcon,
  Default: CPIcon,
};

const PartnerSpecificCpIcon = getPartnerSpecificComponent(cpIcon);

export const IconMapper = new Map<ServiceLine, { icon: React.ReactElement }>([
  [ServiceLine.LAUNDRY_SERVICE, { icon: <PartnerSpecificCpIcon /> }],
  [ServiceLine.SHOE_SERVICE, { icon: <SCIcon /> }],
]);
